import { useCallback, useEffect } from 'react';
import { fetchPagedQuantityPacksApiCompleted, fetchPagedQuantityPacksApiFailed, fetchPagedQuantityPacksApiStarted } from '../../../actions/PlanBuilderActions';
import { usePriceForQuantityPackQuantity } from '../../../hooks/usePagedQuantityPacks';
import { useAppDispatch, useAppSelector } from '../../../reducers';
import { planBuilderPaymentTermForProductsSelector, planBuilderProductConfigurationsSelector } from '../../../selectors/PlanBuilderSelectors';
import QuantityPickerContacts from './QuantityPickerContacts';
import QuantityPickerSeats from './QuantityPickerSeats';
import { jsx as _jsx } from "react/jsx-runtime";
const QuantityPickerContainer = ({
  additionalUnitSku
}) => {
  const dispatch = useAppDispatch();
  const {
    skuId: additionalUnitSkuId,
    quantityPackApiName: additionalUnitQuantityPackApiName,
    productApiName
  } = additionalUnitSku;
  const paymentTerm = useAppSelector(planBuilderPaymentTermForProductsSelector) || 'monthly';
  const productConfigurations = useAppSelector(planBuilderProductConfigurationsSelector);
  const quantityPackConfig = productConfigurations.find(config => config.skuId === additionalUnitSkuId);
  const onError = useCallback(() => {
    dispatch(fetchPagedQuantityPacksApiFailed());
  }, [dispatch]);
  const onCompleted = useCallback(({
    quantityPackPrice
  }) => {
    dispatch(fetchPagedQuantityPacksApiCompleted({
      quantityPackApiName: additionalUnitQuantityPackApiName,
      quantityPackPrice,
      skuId: additionalUnitSkuId
    }));
  }, [additionalUnitQuantityPackApiName, additionalUnitSkuId, dispatch]);

  // fetch paged quantity pack pricing, cache, and dispatch fetch actions
  const {
    loading: loadingPagedQuantityPackData
  } = usePriceForQuantityPackQuantity({
    productApiName,
    quantityPackApiName: additionalUnitQuantityPackApiName,
    additionalQuantity: (quantityPackConfig === null || quantityPackConfig === void 0 ? void 0 : quantityPackConfig.quantity) || 0,
    queryParamTerm: paymentTerm,
    onCompleted,
    onError
  });
  useEffect(() => {
    // Triggering based on `loading` since DFC doesn't have an onLoading callback
    // the onCompleted and onError callbacks will clear this loading state
    if (loadingPagedQuantityPackData) {
      dispatch(fetchPagedQuantityPacksApiStarted());
    }
  }, [loadingPagedQuantityPackData, dispatch]);
  if (additionalUnitQuantityPackApiName === 'additional-sales-seats' || additionalUnitQuantityPackApiName === 'additional-service-seats' || additionalUnitQuantityPackApiName === 'additional-commerce-seats') {
    return /*#__PURE__*/_jsx(QuantityPickerSeats, {
      additionalUnitSkuId: additionalUnitSkuId
    });
  }
  if (additionalUnitQuantityPackApiName === 'additional-marketing-contacts' || additionalUnitQuantityPackApiName === 'additional-legacy-contacts') {
    return /*#__PURE__*/_jsx(QuantityPickerContacts, {
      additionalUnitSku: additionalUnitSku
    });
  }
  return null;
};
export default QuantityPickerContainer;